var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlipFlop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2236 11.6466L18.7941 10.2171L18.4513 9.83564C18.1093 9.65295 17.7099 9.4968 17.2604 9.36965C16.4023 9.12687 15.4124 9.00432 14.4071 8.98461C12.4977 8.94717 10.6883 9.28119 9.72902 9.72915C9.2811 10.6885 8.94711 12.4978 8.98455 14.4072C9.00426 15.4124 9.12681 16.4023 9.36959 17.2605C9.49672 17.7098 9.65283 18.1091 9.83547 18.4511L10.2171 18.7941L11.6466 20.2236C14.0151 22.5921 17.8552 22.5921 20.2236 20.2236C22.5921 17.8552 22.5921 14.0151 20.2236 11.6466Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.32849 8.2678C10.6098 7.7404 12.5534 7.44797 14.4365 7.4849C15.1273 7.49844 15.8275 7.55637 16.5037 7.66864L13.4807 4.30516C11.0203 1.39746 6.60028 1.21361 3.90695 3.90695C1.21361 6.60028 1.39746 11.0203 4.30517 13.4807L7.66853 16.5036C7.55627 15.8275 7.49835 15.1272 7.48481 14.4366C7.44788 12.5534 7.74032 10.6097 8.26776 9.32839L7.22702 8.28765C6.93413 7.99476 6.93413 7.51989 7.22702 7.22699C7.51992 6.9341 7.99479 6.9341 8.28768 7.22699L9.32849 8.2678Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlipFlop);
export default __webpack_public_path__ + "static/media/flip-flop.7bb8a240532894b505ed8f7ba1e9449d.svg";
export { ForwardRef as ReactComponent };